import React, { forwardRef, InputHTMLAttributes } from 'react';
import styled from './Input.module.css';
import errorIcon from '../../assets/images/errorIcon.svg';
import { useTranslation } from 'react-i18next';

interface Props extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
    onChange: (value: string) => void;
    label?: string;
    subLabel?: string;
    error?: string;
    spinnerStep?: number;
}

const Input = forwardRef<HTMLInputElement, Props>(({ label, subLabel, error, type = 'text', className, onChange, spinnerStep, ...rest }, ref) => {
    const { t } = useTranslation();

    return (
        <div className={[styled.Container, className ? className : ''].join(' ')}>
            {label && <p className={styled.Label}>{label}</p>}
            <div className={styled.InputContainer}>
                <input
                    ref={ref}
                    type={type}
                    step={spinnerStep}
                    onChange={e => onChange(e.target.value)}
                    className={[styled.Input, error ? styled.Error : ''].join(' ')}
                    {...rest}
                />
                {error && <img src={errorIcon} alt="Error" className={styled.ErrorIcon} />}
            </div>
            <p className={[styled.SubLabel, error ? styled.Error : ''].join(' ')}>{error ? t(error) : subLabel}</p>
        </div>
    );
});

Input.displayName = 'Input';

export default Input;
